import React from 'react'
import { connect } from 'react-redux'
import { getMessagesById } from '../../../services/messages'

function Notification ({ aside, id }) {
  const item = aside.find(item => item.id === id)
  const notifications = getMessagesById(id).filter(msg => msg.is_unread)

  if (notifications.length === 0 || item.read) return null

  return <span className='channels__notification'>{notifications.length}</span>
}

const mapStateToProps = ({ aside }) => ({ aside })

export default connect(mapStateToProps)(Notification)
